import ajax from '@/utils/request'

// 列表
export const adminsList = data => ajax('/api/admins/get/list/', data, 'POST')
// 详情
export const adminsDetail = data => ajax('/api/admins/get/', data, 'GET')
// 状态更新
export const adminsState = data => ajax('/api/admins/update/state/', data, 'POST')
// 添加管理员
export const adminsAdd = data => ajax('/api/admins/addAdmin/', data, 'POST')
// 编辑管理员
export const adminsEdit = data => ajax('/api/admins/updateAdmin/', data, 'POST')
// 删除管理员
export const adminsDel = data => ajax('/api/admins/del/list', data, 'POST')
